import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION3: PdfComponent = {
  type: 'section',
  id: 's3s3',
  title: '3. Fulfilment Process',
  content: [
    {
      type: 'altText',
      id: 's3s3heading',
      content: ['Kanda must ensure:'],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's3s3bullets',
      bulletType: 'alpha',
      content: [
        {
          copy: 'Goods/services are delivered to the address listed in the Credit Agreement and signed for.',
        },
        {
          copy: 'A signed satisfaction certificate is obtained from the Customer once fulfilment is complete and retained by Kanda. Coercion or pressure to sign is prohibited.',
        },
        {
          copy: "If a Customer alleges duress in signing, the Customer's version will be deemed factually correct and the transaction treated as an Exception subject to unwinding and potential indemnity claims.",
        },
        {
          copy: 'Fulfilment cannot be reported to the lender until signed documentation is provided and accepted. This documentation must match what was agreed and fall within the scope of Permitted Goods and Services and Sales Channels.',
        },
        {
          copy: 'Misreporting fulfilment constitutes a Material Breach and may trigger reversal of the transaction.',
        },
        {
          copy: 'Upon notification of fulfilment, the Credit Agreement is added to the settlement file, processed daily.',
        },
        {
          copy: 'Fulfilment notification may be submitted manually or through automated system integrations.',
        },
      ],
    },
  ],
};
